import React, { Component } from 'react'
import { connect } from 'react-redux'
import { recover } from '../actions/userActions'
import {Redirect, Link} from 'react-router-dom'

@connect((store)=>{
  return {
    auth: store.user.auth,
    recoverProgress: store.user.recoverProgress,
    recoverSuccess: store.user.recoverSuccess,
    error: store.user.recoverError,
  } 
})
class Recover extends Component {

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.dispatch(recover(this.email.value))
  }

  render() {

    if(this.props.auth){
      return (<Redirect to='/dashboard'/>)
    }

    if(this.props.loginProgress){
      return (
      <section className="section-form color-1">
      <div className="loader"></div>
      </section>)
    }
    
    return (
      <section className="section-form color-1">
          <h1 className="section-title">Password Recovery</h1>
          <h3 style={{fontWeight: '400',fontSize: '16px',color: 'rgba(255, 255, 255, 0.59)'}} 
    className="section-subtitle">Please type your registered e-mail below</h3>
          {this.props.recoverSuccess?
          <p>Success: Please check your e-mail address</p>:null
          }
          {this.props.error?
          <p>Error: {this.props.error.message}</p>:null
          }
          <form onSubmit={this.handleSubmit}>
            <div className="formflex">
            <input className="form-input formitem" required type="email" ref={(email) => this.email = email} placeholder="Email"/>
            <div className="formitem">
            <button type="submit" className="btn-register btn btn-primary">Reset Password</button>
            </div>
            </div>
        </form>
      </section>
    );
  }
}

export default Recover;



// WEBPACK FOOTER //
// ./src/components/Recover.js